<template>
  <div ref="checkout-payment">
    <v-layout row px-5>
      <v-flex md3>
        <div class="payment-info px-5 py-5">
          <v-icon style="font-size: 70px">{{creditCardIcon}}</v-icon>
          <div>Total Amount</div>
          <fancy-price :price="totalPrice"></fancy-price>
        </div>
      </v-flex>
      <v-flex md9 pl-5 mt-3>
        <v-card flat outline class="outline">
          <v-card-title v-if="paymentMethods.length > 0">
            <v-flex xs8>
              <v-select label="Payment Method"
                        :items="paymentMethods"
                        item-text="description"
                        item-value="id"
                        v-model="payment_method_id"
                        clearable
                        dense
                        flat
                        placeholder="Use Credit Card Below"
                        @change="$emit('change', payment_method_id)"/>
            </v-flex>
            <v-flex xs4 class="right-align">
              <v-icon>fab fa-cc-amex</v-icon>
              <v-icon>fab fa-cc-discover</v-icon>
              <v-icon>fab fa-cc-mastercard</v-icon>
              <v-icon>fab fa-cc-visa</v-icon>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <template v-if="!payment_method_id">
              <v-text-field label="Cardholder Name"
                            prepend-icon="mdi-account"
                            v-model="creditCard.name"
                            :rules="requiredRules"/>
              <v-layout row>
                <v-flex xs5>
                  <v-text-field label="Credit Card Number" :prepend-icon="creditCardIcon" :mask="creditCardMask" v-model="creditCard.number" :rules="creditCardRules"></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field label="Expiration" prepend-icon="mdi-calendar" mask="##/##" return-masked-value v-model="creditCard.expiration" :rules="requiredRules"></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="Security Code" prepend-icon="mdi-lock" mask="####" v-model="creditCard.security" :rules="securityCodeRules"></v-text-field>
                </v-flex>
              </v-layout>
              <v-switch label="Save credit card for faster check outs" v-model="creditCard.store"/>
            </template>
            <template v-else>
              <h4 class="mb-3">Billing Information</h4>
              <p>
                Using
                {{selectedPaymentMethod.brand}}
                {{selectedPaymentMethod.last_four}} -
                {{selectedPaymentMethod.name}}
              </p>
              <display-address :data="selectedPaymentMethod"/>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import FancyPrice from '../widgets/fancy-price'
  import DisplayAddress from '../widgets/display-address'

  export default {
    props: {
      paymentMethods: Array,
      creditCard: Object,
      totalPrice: Number
    },

    data () {
      return {
        payment_method_id: '',
        defaultCard: 'fal fa-credit-card',
        requiredRules: [
          v => !!v || 'Cannot be blank'
        ],
        creditCardRules: [
          v => !!v || 'Cannot be blank',
          v => this.getCardType(v) !== this.defaultCard || 'Invalid credit card type',
          v => v.length >= 15 || 'Invalid credit card number'
        ],
        securityCodeRules: [
          v => !!v || 'Cannot be blank',
          v => v.length >= 3 || 'Invalid security code'
        ]
      }
    },

    components: {
      fancyPrice: FancyPrice,
      displayAddress: DisplayAddress
    },

    computed: {
      creditCardIcon () {
        var ccType
        if (this.selectedPaymentMethod) {
          ccType = `fab fa-cc-${this.selectedPaymentMethod.brand.toLowerCase()}`
        } else if (this.creditCard.number) {
          ccType = this.getCardType(this.creditCard.number)
        } else {
          ccType = this.defaultCard
        }
        return ccType
      },

      creditCardMask () {
        if (this.creditCardIcon === 'fab fa-cc-amex') {
          return '####-######-#####'
        }
        return '####-####-####-####'
      },

      selectedPaymentMethod () {
        if (this.payment_method_id) {
          let obj = this.paymentMethods.find(o => o.id === this.payment_method_id)
          return obj.method
        } else {
          return false
        }
      }
    },

    methods: {
      methodDescription (method) {
        return method.description + method.name
      },

      getCardType (number) {
        // visa
        var re = new RegExp('^4')
        if (number.match(re) != null) return 'fab fa-cc-visa'

        // Mastercard
        if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number)) return 'fab fa-cc-mastercard'

        // AMEX
        re = new RegExp('^3[47]')
        if (number.match(re) != null) return 'fab fa-cc-amex'

        // Discover
        re = new RegExp('^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)')
        if (number.match(re) != null) return 'fab fa-cc-discover'

        // Diners
        re = new RegExp('^36')
        if (number.match(re) != null) return 'fab fa-cc-diners-club'

        // Diners - Carte Blanche
        re = new RegExp('^30[0-5]')
        if (number.match(re) != null) return 'fab fa-cc-diners-club'

        // JCB
        re = new RegExp('^35(2[89]|[3-8][0-9])')
        if (number.match(re) != null) return 'fab fa-cc-jcb'

        // Visa Electron
        re = new RegExp('^(4026|417500|4508|4844|491(3|7))')
        if (number.match(re) != null) return 'fab fa-cc-visa'

        return this.defaultCard
      }
    }
  }
</script>



// WEBPACK FOOTER //
// payment.vue?133ab6b0